import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { animateScroll as scroll } from 'react-scroll';

import { Plus } from '../../../common/filter/Styles';
import useOnClickOutside from '../../../../../hooks/useOnClickOutside';

const Wrapper = styled.div`
  border: 1px solid black;
  cursor: pointer;
  padding: 10px 20px;

  .ais-Panel-header {
    margin: 0;
    border: none;
    /* border: 1px solid gray; */
    display: flex;
    padding-bottom: 0;
    justify-content: space-between;
    .header-name {
      font-family: ${({ theme }) => theme.fonts.primary};
      font-style: normal;
      font-weight: ${({ theme }) => theme.old ? 'bold' : 600};
      font-size: 13px;
      line-height: 23px;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      color: ${({ theme }) => theme.colors.charcoal};
    }
  }
  .plus {
    position: relative;
    top: 7px;
    bottom: 0;
  }
  .ais-Panel-body {
    box-shadow: rgba(0, 0, 0, 0.2) 0px 8px 16px 0px;
    border: 1px solid black;
    position: absolute;
    background: white;
    padding: 20px 100px 20px 20px;
    z-index: 10;
    top: 489px;
  }
  @media (max-width: 1100px) {
    .plus {
      right: 15px;
    }
    .ais-Panel-header {
      .header-name {
        font-size: 10px;
      }
    }
  }

  @media (max-width: 992px) {
    .ais-Panel-body {
      padding: 20px 20px 20px 20px;
      top: auto;
      left: 0;
      width: 100%;
      max-height: 300px;
      overflow-y: auto;
      top: 102px;
      border: none;
      box-shadow: rgba(0, 0, 0, 0.2) 0px 8px 16px 0px;
      border-bottom: 1px solid black;
    }
    .ais-Panel-header {
      .header-name {
        font-size: 13px;
      }
    }
  }
  @media (max-width: 350px) {
    .ais-Panel-body {
      padding: 20px 0px 20px 3px;
    }
  }
`;

const CustomPanel = ({ isMobile, header, footer, children, className }) => {
  const [collapsed, setCollapsed] = useState(true);
  const ref = useRef(null);
  useOnClickOutside(ref, () => setCollapsed(true));
  return (
    <Wrapper ref={ref} open={!collapsed} className={className}>
      <div className="ais-Panel">
        {header && (
          <div
            className="ais-Panel-header"
            onClick={() => {
              setCollapsed(!collapsed);
              if (collapsed && isMobile) {
                scroll.scrollTo(115, {
                  duration: 250,
                  delay: 0,
                  smooth: 'easeInOutQuart'
                });
              }
            }}
          >
            <div className="header-name">{header}</div>

            <div className="collapse-button">
              <img
                src={
                  collapsed
                    ? '/assets/pdp/arrow-down.svg'
                    : '/assets/pdp/arrow-up.svg'
                }
                alt="arrow collapse filters"
              />
            </div>
          </div>
        )}
      </div>
      <div className={`ais-Panel-body ${collapsed ? 'd-none' : ''}`}>
        {children}
      </div>
      {footer && <div className="ais-Panel-footer">{footer}</div>}
    </Wrapper>
  );
};
export default CustomPanel;
